import { cn } from "@lib/utils";
import React, { useId } from "react";
import { BaseInput } from "./input-base";

const Input = React.forwardRef(
	(
		{
			label,
			required = false,
			hint,
			error,
			as = "input",
			id,
			wrapperClassName,
			className,
			children,
			...props
		},
		ref,
	) => {
		const generatedId = useId();
		const inputId = id ?? generatedId;
		const Component = as;

		return (
			<div className={cn("flex w-full flex-col gap-1.5", wrapperClassName)}>
				{label && (
					<label
						htmlFor={inputId}
						className="text-sm font-bold text-black"
					>
						{label}
						{required && <span className="ml-1 text-red-500">*</span>}
					</label>
				)}

				{as === "input" ? (
					<BaseInput
						id={inputId}
						ref={ref}
						className={cn("text-base", className)}
						{...props}
					/>
				) : (
					<Component
						id={inputId}
						ref={ref}
						className={cn(
							"underline-input w-full border-0 border-b-2 border-[#063447] bg-transparent px-0 pb-2 text-base text-stone-900 caret-[#063447] placeholder:text-stone-500 transition-colors focus:border-[#063447] focus-visible:outline-none disabled:border-stone-200 disabled:text-stone-400",
							as === "textarea"
								? "min-h-[120px] resize-y pt-2"
								: "min-h-[48px]",
							as === "select" ? "cursor-pointer pr-8 appearance-none" : "",
							className,
						)}
						{...props}
					>
						{children}
					</Component>
				)}

				{hint && <p className="text-xs text-stone-600">{hint}</p>}
				{error && <p className="text-xs text-red-600">{error}</p>}
			</div>
		);
	},
);
Input.displayName = "Input";

export { Input };
